class Header extends React.Component {

    render() {
        return (
            <div className='row'>
                <div className='col-12'>
                    <div className={'profile-main__container--header '+(this.props.first ? 'profile-main__container--first' : '')}>
                        {this.props.label}
                    </div>
                </div>
            </div>
        );
    }
}

export default Header;


// WEBPACK FOOTER //
// ./ui_src/app/components/profile/view/Header.react.jsx